console.log("home-mataro-form")
import _forEach from 'lodash/forEach'

const form = new Vue({
    el: '#matarohomeform',
    data() {
        return {
            form: {
                name: '',
                email: '',
                terms: false,
            },
            default: {
                name: '',
                email: '',
                terms: false,
            },
            validation: {
                name: 'required',
                email: 'required',
                // phone: 'required',
            },
            errors: {
                name: false,
                email: false,
                terms: false,
            },
            requestStatus: 'unsent',
        }
    },
    methods: {

        validateInputs() {
            let hasErrors = false;
            _forEach(this.validation, (field, key) => {
                this.errors[key] = false
                if(key === 'email'){
                    var phoneRGEX = /^[0-9]{9}$/;
                    var emailRGEX = /^.+@.+$/;
                    var phoneResult = phoneRGEX.test(this.form[key]);
                    var emailResult = emailRGEX.test(this.form[key]);
                    if(!emailResult && !phoneResult){
                        this.errors[key] = true;
                        hasErrors = true
                    }
                }
                if(!this.form[key].length){
                    this.errors[key] = true
                    hasErrors = true
                }
            })

            this.errors.terms = false
            if(!this.form.terms){
                console.log('error terms');
                this.errors.terms = true
                hasErrors = true
            }
            if(hasErrors)
                return false

            return true
        },

        submit(){
            if(!this.validateInputs()){
                return false
            }
            //codi per events que mostra un missatge a sobre el mateix formulari i no envia a l'usuari a cap altre pàgina
            // axios.post(this.$el.action, this.form)
            //     .then(response => {
            //         if(response.data.success){
            //             this.$refs.options.classList.add('mounted')
            //         }
            //     });
            $("#matarohomeform").submit();
        },
    }
});
